import React, { useState, useContext, useEffect } from 'react';
import classNames from 'classnames/bind';
import AppContext from '../../context/AppContext';

import styles from './CartolaBanner.module.scss';

function CartolaBanner() {
  const { setHandleBannerCartola } = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const cx = classNames.bind(styles);
  let valueClick = 0;

  const handleCloseBanner = () => {
    setOpen(false);
  };

  const handleOpenBannerCartola = (teamModal, teamName) => {
    window.ge.user
      .getTeam()
      .then((time) => {
        const teamUser = time.futebol.name;
        if (teamModal === teamUser && valueClick === 0) {
          const contentTeamUser = document.getElementById('teamHeart');
          contentTeamUser.innerHTML = ` ${teamName}`;
          setOpen(true);
          valueClick += 1;
        }
      })
      .catch((error) => {
        console.log(error, 'Não possui time do coração'); // eslint-disable-line
      });
  };

  useEffect(() => {
    setHandleBannerCartola((state) => ({
      ...state,
      handleOpenBannerCartola,
    }));
  }, []); // eslint-disable-line

  return (
    <div
      className={cx({
        wrapperCartola: true,
        wrapperCartolaOpen: open,
      })}
    >
      <div className={styles.cartolaContent}>
        <div className={styles.cartolaHeader}>
          <div className={styles.cartolaLogo}>
            <img
              className={styles.cartolaLogoImg}
              src="https://s3.glbimg.com/v1/AUTH_08fb001c60b847468664307c11fa9dc9/public/2022/3/pnwBildGdj40HHIaV8AH.svg"
              alt="logo do cartola em branco"
            />
          </div>
          <div className={styles.cartolaParagraph}>
            <p className={styles.cartolaParagraphText}>
              Aproveita que está avaliando o elenco do
              <b id="teamHeart">time</b> e escale seu time!
            </p>
          </div>
        </div>
        <div className={styles.cartolaShare}>
          <div className="container__cartola_time">
            <img
              className={styles.cartolaTimeImage}
              src="https://s3.glbimg.com/v1/AUTH_58d78b787ec34892b5aaa0c7a146155f/default/how-to-home-editorial/esquadrao.png"
              alt="imagem pequena de um time de futebol"
            />
          </div>
          <div className={styles.cartolaButton}>
            <a href="https://ge.globo.com/cartola/">
              <button className={styles.cartolaButtonEscale}>
                Escale agora!
              </button>
            </a>
          </div>
          <div className={styles.cartolaButtonClose}>
            <div className={styles.cartolaButtonSignal}>
              <button
                className={styles.cartolaButtonCloseInfo}
                onClick={handleCloseBanner}
              >
                <img
                  className={styles.cartolaButtonCloseImage}
                  src="https://s3.glbimg.com/v1/AUTH_08fb001c60b847468664307c11fa9dc9/public/2022/3/3nOctANGGLQ4aY1G3Jj1.svg"
                  alt="icone para fechar a publicidade"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartolaBanner;
